import { useTranslation } from 'react-i18next';
import { useMutation } from '@tanstack/react-query';
import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';

import { authApi } from '../../api/auth.api';
import { Button } from '@/shared/ui/atoms/Button';
import { Input } from '@/shared/ui/atoms/Input';
import { FontIcon } from '@/shared/ui/atoms/FontIcon';
import '../AuthForm.styl';

export function ForgotForm() {
  const { t } = useTranslation(undefined, { keyPrefix: 'auth.forgot' });
  const [email, setEmail] = useState('');
  const [done, setDone] = useState(false);
  const forgot = useMutation({
    mutationFn: () => authApi.forgot(email.trim()),
    // The response is deliberately the same whether or not the address exists.
    onSettled: () => setDone(true)
  });
  const submit = (e: FormEvent) => {
    e.preventDefault();
    if (email.trim()) forgot.mutate();
  };
  return (
    <form className="f-auth" onSubmit={submit} noValidate>
      <h1 className="f-auth__title">{t('title')}</h1>
      <p className="f-auth__lead">{t('lead')}</p>
      <div className="f-auth__fields">
        <Input type="email" autoComplete="email" placeholder={t('email')} value={email} onChange={(e) => setEmail(e.target.value)} disabled={done} leading={<FontIcon name="envelop2" />} />
      </div>
      {done ? (
        <div className="f-auth__status" role="status">
          {t('done')}
        </div>
      ) : (
        <Button type="submit" block className="f-auth__submit" loading={forgot.isPending}>
          {t('submit')}
        </Button>
      )}
      <div className="f-auth__foot">
        <Link className="f-auth__link" to="/login">
          {t('back')}
        </Link>
      </div>
    </form>
  );
}
